/** Полоса «Договор не синхронизирован с Bitrix»: стало видно по `sync_stale` или по ошибке синхронизации последней правки. */
import { useMutation } from "@tanstack/react-query";

import { type ContractChange, syncContract, useContractRefresh, writeError } from "@/lib/contract";
import { btn } from "@/lib/panelBtn";

/** `can` — правка доступна (право, запись включена, договор этой сделки): решает карточка договора. */
export function SyncBar({ dealId, dogovorId, chatId, stale, changes, can }: { dealId: number; dogovorId: number; chatId: number | null; stale: boolean; changes: ContractChange[] | undefined; can: boolean }) {
  const refresh = useContractRefresh(dealId, dogovorId, chatId);
  const m = useMutation({ mutationFn: () => syncContract(dogovorId, chatId), onSettled: refresh });
  // Журнал приходит новыми сверху; смотрим последнюю правку, у которой был шаг синхронизации.
  const last = changes?.find((c) => c.sync && c.sync !== "none");
  const bad = last?.sync === "error";
  if (!stale && !bad) return null;
  const r = m.data?.sync;
  return (
    <div className="flex flex-col gap-1 rounded-[var(--radius-ui)] border border-err/40 bg-err/10 p-2 text-[12.5px]" data-annot="синхронизация договора">
      <div className="font-medium text-err">Договор не синхронизирован с Bitrix</div>
      {bad && last?.sync_detail && <div className="break-words text-fg-muted">{last.sync_detail}</div>}
      {m.isError && <div className="whitespace-pre-wrap text-err">{writeError(m.error)}</div>}
      {r && r.status !== "ok" && <div className="text-err">{r.detail ?? r.status}</div>}
      {m.data?.warnings.map((w, i) => (
        <div key={i} className="text-[12px] font-medium text-err">
          {w}
        </div>
      ))}
      {can && (
        <button type="button" disabled={m.isPending} onClick={() => m.mutate()} className={`${btn.outline} self-start`}>
          {m.isPending ? "Синхронизирую…" : "Синхронизировать"}
        </button>
      )}
    </div>
  );
}
